import { Component, Input } from '@angular/core';

import { BarChartDatePeriod } from '../../../../tms-shared';
import { ChartWeeksSalesOrdersService } from '../../../services';

@Component({
  selector: 'app-sales-order-chart',
  templateUrl: './sales-order-chart.component.html',
  styleUrl: './sales-order-chart.component.scss',
})
export class SalesOrderChartComponent {
  @Input() productId: string = '';
  @Input() customerId: string = '';
  @Input() barChartPeriod: BarChartDatePeriod = BarChartDatePeriod.Week;
  @Input() xRotation: number = 0;

  readonly yNameSalesValue = $localize`Sales Value`;

  constructor(public chartWeeksSalesOrdersService: ChartWeeksSalesOrdersService) {}
}
